
<template>
    <!-- eslint-disable -->
    <StepTemplate :hideNavigation="true">
        <!-- Main Heading -->
        <h1 class="title type--centred type--l type--i">Get A Quote</h1>

        <div class="form-group type--sans type--s">
            <div class="journey-types">

                <!-- Aircraft Type -->
                <!-- <div class="radio-pills will-grow">
                    <FlytRadioPill  v-if="!defaultDestinationLocationSet || (defaultDestinationLocationSet && aircraftCategory === 'helicopter')" id="type__helicopter" :modelValue="aircraftCategory" value="helicopter" @change="onAircraftCategoryChange">
                        <HelicopterIcon class="radio-pill__icon"/>
                        <span>Helicopter</span>
                    </FlytRadioPill>
                    <FlytRadioPill  v-if="!defaultDestinationLocationSet || (defaultDestinationLocationSet && aircraftCategory === 'aeroplane')" id="type__airplane" :modelValue="aircraftCategory" value="aeroplane" @change="onAircraftCategoryChange">
                        <AirportIcon class="radio-pill__icon"/>
                        <span>Jet</span>
                    </FlytRadioPill>
                </div> -->

                <!-- Single or Return -->
                <div class="radio-pills will-grow">
                    <FlytRadioPill id="type__single" :modelValue="isReturn" :value="false" @change="onIsReturnChange">
                        <span>One-Way</span>
                    </FlytRadioPill>
                    <FlytRadioPill id="type__return" :modelValue="isReturn" :value="true" @change="onIsReturnChange">
                        <span>Return</span>
                    </FlytRadioPill>
                </div>
            </div>
        </div>

        <!-- Journey -->
        <div class="form-group">
            <ul class="journey type--sans">

                <!-- Optional pickup -->
                <li class="journey__stop is-transfer" v-if="!isLocationEmpty('origin')">
                    <div class="journey__stop-marker">
                        <div class="journey__stop-icon">
                            <TaxiBorderIcon/>
                        </div>
                    </div>
                    <div class="journey__stop-content">
                        <FlytTransfer locationType="origin" placeholder="Transfer from" />
                    </div>
                </li>

                <!-- Origin -->
                <li class="journey__stop is-main">
                    <div class="journey__stop-marker">
                        <FlytJourneyLocationIcon/>
                    </div>
                    <div class="journey__stop-content">
                        <FlytLocationSelector
                            placeholder="Travelling From"
                            :locationType="'origin'"
                            :hasError="$v.origin.$error"
                            :focusOnLoad="!isMobile"
                            v-model="$v.origin.$model"
                        />
                    </div>
                </li>

                <!-- Destination -->
                <li class="journey__stop is-main">
                    <div class="journey__stop-marker">
                        <FlytJourneyLocationIcon/>
                    </div>
                    <div class="journey__stop-content">
                        <FlytLocationSelector
                            placeholder="Travelling To"
                            :locationType="'destination'"
                            :hasError="$v.destination.$error"
                            v-model="$v.destination.$model"
                        />
                    </div>
                </li>

                <!-- Optional pickup -->
                <li class="journey__stop is-transfer" v-if="!isLocationEmpty('destination') && !this.defaultDestinationLocationSet">
                    <div class="journey__stop-marker">
                        <div class="journey__stop-icon">
                            <TaxiBorderIcon/>
                        </div>
                    </div>
                    <div class="journey__stop-content">
                        <FlytTransfer locationType="destination" placeholder="Transfer to" />
                    </div>
                </li>

            </ul>
        </div>

        <!-- Dates and Times -->
        <div class="form-group">
            <div class="booking-times">

                <!-- Outbound Dates & Times -->
                <div class="booking-times__outbound">
                    <fieldset class="booking-times__type">
                        <!-- Outbound depart or arrival -->
                        <legend class="legend">Depart</legend>
                        <div class="radio type--s">
                            <input
                                id="outbound__depart"
                                type="radio"
                                name="outbound__type"
                                :value="false"
                                v-model="timeIsArrival"
                                checked
                            />
                            <label class="label" for="outbound__depart">Depart At</label>
                        </div>
                        <div class="radio type--s">
                            <input
                                id="outbound__arrive"
                                type="radio"
                                name="outbound__type"
                                :value="true"
                                v-model="timeIsArrival"
                            />
                            <label class="label" for="outbound__arrive">Arrive By</label>
                        </div>
                    </fieldset>
                    <div class="booking-times__datetime">
                        <FlytDateSelector v-model="$v.date.$model" :class="{'has-error' : $v.date.$error}" />
                        <FlytTimeSelector
                            v-model="$v.time.$model"
                            ref="time"
                            :class="['booking-times__time', {'has-error' : $v.time.$error}]"
                        />
                    </div>
                </div>

                <!-- Return Dates & Times -->
                <div class="booking-times__inbound" @click="setIsJourneyReturn(true)">
                    <fieldset class="booking-times__type">
                        <!-- Return depart or arrival -->
                        <legend class="legend">Return</legend>
                        <div class="radio type--s">
                            <input
                                id="inbound__depart"
                                type="radio"
                                name="inbound__type"
                                :disabled="!isReturn"
                                :value="false"
                                v-model="returnTimeIsArrival"
                            />
                            <label class="label" for="inbound__depart">Depart At</label>
                        </div>
                        <div class="radio type--s">
                            <input
                                id="inbound__arrive"
                                type="radio"
                                name="inbound__type"
                                :disabled="!isReturn"
                                :value="true"
                                v-model="returnTimeIsArrival"
                            />
                            <label class="label" for="inbound__arrive">Arrive By</label>
                        </div>
                    </fieldset>
                    <div class="booking-times__datetime">
                        <FlytDateSelector
                            v-model="$v.returnDate.$model"
                            ref="returnDate"
                            alignRight
                            :disabledUntil="returnDatesDisabledUntil"
                            
                            :class="{'has-error' : $v.returnDate.$error}"
                        />
                        <FlytTimeSelector
                            v-model="$v.returnTime.$model"
                            ref="returnTime"
                            
                            :class="['booking-times__time', {'has-error' : $v.returnTime.$error}]"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Number of Passengers -->
        <div class="form-group">
            <FlytNumberSelector v-model="passengers"/>
        </div>

        <!-- Submit -->
        <div class="form-group">
            <button
                class="submit-button button is-primary is-wide type--serif type--m"
                @mouseover="$v.$touch()"
                @mouseout="$v.$reset()"
                @click="submit"
            >Instant Quote</button>
        </div>
        <!-- Empty footer slot -->
        <template #footer></template>
    </StepTemplate>
</template>

<script>
/* eslint-disable */
import StepTemplate from "./StepTemplate"
import FlytTimeSelector from "@/components/formfields/FlytTimeSelector2"
import FlytDateSelector from "@/components/formfields/FlytDateSelector"
import FlytNumberSelector from "@/components/formfields/FlytNumberSelector"
import FlytLocationSelector from "@/components/formfields/FlytLocationSelector"
import FlytTransfer from "@/components/formfields/FlytTransfer"
import FlytRadioPill from "@/components/formfields/FlytRadioPill"
import { required, requiredIf } from "vuelidate/lib/validators"
import { mapGetters, mapActions, mapMutations } from "vuex"
import { createHelpers } from "vuex-map-fields"
import AirportIcon from "@/assets/flyt-icons_airport.svg?inline"
import HelicopterIcon from "@/assets/flyt-icons_helicopter.svg?inline"
import TaxiBorderIcon from "@/assets/flyt-icons_taxi--border.svg?inline"
import FlytJourneyLocationIcon from "@/components/FlytJourneyLocationIcon"

const { mapFields } = createHelpers({
    getterType: "bookingForm/getField",
    mutationType: "bookingForm/updateField",
})

export default {
    name: "JourneyStep",

    components: {
        StepTemplate,
        FlytTimeSelector,
        FlytDateSelector,
        FlytNumberSelector,
        FlytLocationSelector,
        FlytRadioPill,
        FlytTransfer,
        AirportIcon,
        HelicopterIcon,
        TaxiBorderIcon,
        FlytJourneyLocationIcon
    },

    computed: {
        ...mapFields([
            "isReturn",
            "date",
            "time",
            "timeIsArrival",
            "returnDate",
            "returnTime",
            "returnTimeIsArrival",
            "passengers",
            "aircraftCategory"
        ]),
        ...mapGetters("bookingForm", ["isLocationEmpty", "formattedDate", "formattedReturnDate", "formattedJourney", "defaultDestinationLocationSet", "locationValue", "aircraftCategory"]),
        ...mapGetters("browser", ["isMobile"]),
        ...mapGetters("map", ["journeyDestinationDetails"]),

        /**
         * Journey locations in vuex store
         */
        origin() {
            return this.$store.getters["bookingForm/locationValue"]("origin")
        },
        destination() {
            return this.$store.getters["bookingForm/locationValue"]("destination")
        },

        /**
         * Make return dates available after outbound date, or today
         */
        returnDatesDisabledUntil() {
            return this.date || new Date()
        },

        /**
         * Form data
         */
        payload() {
            return {
                date: this.formattedDate,
                time: this.time,
                time_is_arrival: this.timeIsArrival,
                is_return: this.isReturn,
                return_date: this.formattedReturnDate,
                return_time: this.returnTime,
                return_time_is_arrival: this.returnTimeIsArrival,
                steps: this.formattedJourney,
                passengers: this.passengers,
                aircraft_category: this.aircraftCategory
            }
        },
    },

    watch: {
        /**
         * Clear all location data each time aircraft category changes
         */
        aircraftCategory() {
            this.clearAllLocations()
        },
        returnDate(newValue, oldValue) {
            if (newValue!== '' && newValue !== null && newValue !== oldValue) {
                // React to the return date being set
                this.setIsReturn(true);
            } else {
                this.setIsReturn(false);
            }
        }
    },

    validations: {
        origin: { required },
        destination: { required },
        date: { required },
        time: { required },
        returnDate: {
            required: requiredIf(function () {
                return this.isReturn
            }),
        },
        returnTime: {
            required: requiredIf(function () {
                return this.isReturn
            }),
        },
    },

    methods: {
        ...mapActions("bookingForm", [
            "storeLocationValue",
            "deleteLocationValue",
            "submitJourney",
            "storeAircraftCategory"
        ]),
        ...mapMutations("map", [
            "clearSearchingMarkers",
            "clearAllJourneyMarkers"
        ]),
        ...mapMutations("bookingForm", [
            "setIsReturn",
            "setStepLoading",
            "setAircraftCategory"
        ]),

        /**
         * Store whether journey is return and the validation
         * otherwise it errors if this value changes.
         */
        setIsJourneyReturn(yesOrNo) {
            this.setIsReturn(yesOrNo)
            this.$nextTick(() => this.$v.$reset())
        },

        /**
         * Check validation and return if invalid.
         * Otherwise submit journey, set the second step to loading and transition there.
         */
        submit() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            this.submitJourney(this.payload)
            this.setStepLoading(2)
            this.$emit("next")
        },

        /**
         * Reset all location data
         */
        clearAllLocations() {
            if (!this.defaultDestinationLocationSet) {
                this.deleteLocationValue('destination')
            }
            this.deleteLocationValue('origin')
        },

        /**
         * Clear return form fields
         */
        clearBookingFormReturnDateAndTime() {
            if (this.$refs.returnDate?.reset){
                this.$refs.returnDate.reset()
            }
            if (this.$refs.returnTime?.reset){
                this.$refs.returnTime.reset()
            }
        },

        /**
         * Clear any current markers and update the category
         */
        onAircraftCategoryChange(category) {
            this.clearSearchingMarkers()
            this.clearAllJourneyMarkers()
            this.storeAircraftCategory(category)
        },

        /**
         * Update whether journey is return
         * If not, clear the return data
         */
        onIsReturnChange(isReturn) {
            this.setIsReturn(isReturn)
            if (!isReturn) this.clearBookingFormReturnDateAndTime()
        }
    },
}
</script>

<style lang="scss" scoped>
.title {
    line-height: 1;
    margin-bottom: 0.75rem;
}

.journey-types {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: -0.5rem;
}

.journey__stop-icon {
    color: $colour-teal;
    svg {
        fill: currentColor;
    }
}

.booking-times {
    display: flex;
    flex-direction: row;
}

.booking-times__outbound,
.booking-times__inbound {
    flex: 50%;
    position: relative;
}

.booking-times__outbound {
    padding-right: 0.5rem;
    .vdp-datepicker__calendar {
        left: 0;
    }
}

.booking-times__inbound {
    padding-left: 0.5rem;
    .vdp-datepicker__calendar {
        right: 0;
    }
}

.booking-times__datetime {
    display: flex;
    flex-direction: row;
    position: relative;
}

.booking-times__date {
    flex: 1 1 75%;
}

.booking-times__time {
    position: relative;
    &:before {
        background: rgba(0, 0, 0, 0.1);
        bottom: 0.5rem;
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0.5rem;
        transform: translateX(-50%);
        width: 1px;
    }
}

.submit-button.is-disabled {
    cursor: not-allowed;
}

// Selected option
.location-selector__selected,
.location-selector__m-selected {
    border-radius: 0.25rem;
    box-shadow: 0 0.0625rem 0.25rem rgba(0, 0, 0, 0.15), 0 0.03125rem 0.125rem rgba(0, 0, 0, 0.05);
    display: block;
    line-height: 1.25;
    padding: 0.5rem 3rem 0.5rem 0.75rem;
    width: 100%;
}

.location-selector__selected-name {
    margin: 0.125rem 0;
}

.location-selector__selected-address {
    color: $colour-pencil--dark;
}
</style>
